import axios, { endpoints } from 'src/utils/axios';

import { CreateSubDTO, NotificationSubscription, SubDTO, UpdateSubDTO } from '../types';

export async function subscribe(payload: CreateSubDTO): Promise<NotificationSubscription> {
  const response = await axios.post<NotificationSubscription>(endpoints.subs, payload);
  return response.data;
}

export async function updateSub(payload: UpdateSubDTO): Promise<NotificationSubscription> {
  const response = await axios.put<NotificationSubscription>(endpoints.subs, payload);
  return response.data;
}
export async function getSubscribe(payload: SubDTO, orgId: string): Promise<boolean> {
  const response = await axios.get<boolean>(endpoints.organization.getSubscribe(orgId), {
    params: payload,
  });
  return response.data;
}
